module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/b14186fb47c2810cdcef772533f33b02.png";